import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { extractDurationAndUnit } from "components/common/TimeUnitInput";
import { THRESHOLD_MODES } from "../types";
const TIME_UNITS = ["HOURS", "MINUTES", "SECONDS"];
const formatBytes = (bytes) => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KiB", "MiB", "GiB", "TiB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`;
};
const EventDefinitionTrafficSummary = ({ config }) => {
  const { t } = useTranslation("enterprise_license");
  if (!config) {
    return null;
  }
  const typedConfig = config;
  const isPercentage = typedConfig.threshold_mode === THRESHOLD_MODES.PERCENTAGE;
  const executeEvery = extractDurationAndUnit(
    moment.duration(typedConfig.execute_every_seconds, "seconds").asMilliseconds(),
    TIME_UNITS
  );
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("license.traffic.threshold_type")), /* @__PURE__ */ React.createElement("dd", null, isPercentage ? t("license.traffic.summary.type_percentage") : t("license.traffic.summary.type_absolute")), /* @__PURE__ */ React.createElement("dt", null, t("license.traffic.summary.threshold")), /* @__PURE__ */ React.createElement("dd", null, isPercentage ? t("license.traffic.summary.threshold_percentage", { threshold: typedConfig.threshold }) : formatBytes(typedConfig.threshold)), /* @__PURE__ */ React.createElement("dt", null, t("license.traffic.time_range_mode")), /* @__PURE__ */ React.createElement("dd", null, t("license.traffic.billing_period_based")), /* @__PURE__ */ React.createElement("dt", null, t("license.traffic.summary.description")), /* @__PURE__ */ React.createElement("dd", null, isPercentage ? t("license.traffic.summary.description_percentage", { threshold: typedConfig.threshold }) : t("license.traffic.summary.description_absolute", { threshold: formatBytes(typedConfig.threshold) })), /* @__PURE__ */ React.createElement("dt", null, t("license.traffic.execute_every")), /* @__PURE__ */ React.createElement("dd", null, executeEvery.duration, " ", executeEvery.unit.toLowerCase()));
};
export default EventDefinitionTrafficSummary;
